import type { MouseEvent } from 'react';

import { isPlainPrimaryClick } from '~/utils/misc';

/** True for a plain primary-button click (not modifier/middle-click new-tab gestures). */
export function isPlainPrimaryRowLinkClick(event: MouseEvent<HTMLAnchorElement>): boolean {
  return isPlainPrimaryClick(event);
}

/** Stops row bubbling; plain left-clicks invoke `onAppNavigate` instead of following `href`. */
export function handleTableRowLinkClick(event: MouseEvent<HTMLAnchorElement>, onAppNavigate: () => void): void {
  event.stopPropagation();
  if (isPlainPrimaryRowLinkClick(event)) {
    event.preventDefault();
    onAppNavigate();
  }
}
